import React from 'react'
import { Map } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../actions/index'
import DetailPageV3MetaItem from './DetailPageV3MetaItem'
import { getMetaItems } from './utils'

/**
 * @param {Object} props - The props
 * @param {Map} props.detailData - The content details data
 * @param {Boolean} props.isInline - If meta should be displayed inline
 * @param {Map} props.staticText - The static text
 * @returns {JSX.Element} DetailPageV3InfoMeta
 */

const DetailPageV3InfoMetaItems = (props) => {
  const {
    detailData = Map(),
    isInline = false,
    staticText,
  } = props

  const metaItems = getMetaItems(detailData)

  return (
    <>
      {metaItems.map((item) => (
        <DetailPageV3MetaItem key={item.get('textKey')} metaItem={item} staticText={staticText} isInline={isInline} />
      ))}
    </>
  )
}

export default connectRedux((state) => ({
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3InfoMetaItems)
